import React, { useEffect, useState } from "react";
import useHandleBoxTypes from "../hooks/useHandleBoxTypes";
import MainStore from "../stores/MainStore";
import activeStore from "./../stores/activeStore";
import ActiveBoxDisplay from "./ActiveBoxDisplay";
import NoneSelectedHolder from "./NoneSelectedHolder";

const ActiveBox = ({ setShowActiveBox, handleActiveBox }) => {
  const { player } = MainStore();
  const { box } = activeStore();
  const { getBoxType } = useHandleBoxTypes();
  const [boxType, setBoxType] = useState(null);

  useEffect(() => {
    if (box) setBoxType(getBoxType(box.type));
  }, [box]);

  return (
    <div
      style={{
        position: "absolute",
        left: "0",
        marginLeft: "10px",
        top: "12%",
        marginTop: "20px",
        backgroundColor: boxType?.colors.primary,
        padding: "10px",
        borderRadius: "1rem/1rem",
        height: "70%",
        width: "12%",
        minWidth: "300px",
        minHeight: "700px",
        border: boxType ? `2px solid ${boxType.colors.secondary}` : null,
      }}
    >
      {box && (
        <ActiveBoxDisplay
          setShowActiveBox={setShowActiveBox}
          box={box}
          handleActiveBox={handleActiveBox}
          boxType={boxType}
        />
      )}
      {!box && (
        <NoneSelectedHolder
          setShowActive={setShowActiveBox}
          width="100%"
          from="Box"
        />
      )}
    </div>
  );
};

export default ActiveBox;
